import { EGDFlsMan, EGDOwner, EGDPerson, EGDPref, Room } from '../../../types';
import { isArray, mayBe, DATA_NOT_AVAILABLE, NO_ATTRIBUTE } from './common';
import { prebPeoples, regPeoples, getCommonRooms, getCmanReg } from './egd_utils';

export const prepareCommonRoomsTable = ({
  rooms,
  id,
  flsMan,
}: {
  rooms: Room[],
  id: string,
  flsMan: EGDFlsMan,
}) => {
  const commonRooms = getCommonRooms(rooms, id);

  const title = 'Семьи, проживающие в квартире (для квартир коммунального типа)';
  const subtitle =
    'указывается количество человек в семье и характеристика занимаемых комнат, а также о наличии/отсутствии в этих семьях тяжелобольных граждан';

  const headers = [
    '№ комнаты',
    'Характеристика комнаты',
    'Общая приведенная площадь',
    'Жилая площадь',
    'ФИО нанимателя (собственника)',
    'Человек в семье',
    'Имеются/не имеются тяжелобольные',
  ];

  const rows = commonRooms.map((room, index) => [
    mayBe(room.nom),
    mayBe(room.roomPlan),
    mayBe(room.sRoomAll, ' кв.м.'),
    mayBe(room.sRoom, ' кв.м.'),
    mayBe(room.oks),
    getCmanReg(flsMan, room.flsid),
    NO_ATTRIBUTE,
  ]);

  const empty = 'Нет данных';

  return { title, subtitle, headers, rows, empty };
};

export const preparePrefTableData = (prefs: EGDPref[]) => {
  const title =
    'Наличие мер социальной поддержки (льготы) по оплате жилого помещения и коммунальных услуг';

  const headers = [
    'ФИО гражданина, имеющего право на меры соц. поддержки',
    'Основание предоставления мер соц. поддержки',
    'Размер льготных скидок',
    'ФИО граждан, проживающих в жилом помещении, на которых распространяются все или часть мер соц. поддержки',
  ];

  const rows = isArray(prefs)
    ? prefs.map((pref, index) => [
        `${index + 1}. ${mayBe(pref.prefOwnerFio)}`,
        mayBe(pref.reasonStr),
        pref.prefKoefList ? mayBe(pref.prefKoefList.join('.')) : DATA_NOT_AVAILABLE,
        mayBe(pref.peopleLinkedPref),
      ])
    : [];

  const empty = 'Нет данных';

  return { title, headers, rows, empty };
};

export const preparePrebPeopleTableData = (people: EGDPerson[]) => {
  const peopleByPreb = prebPeoples(people);

  const title = 'Зарегистрированные по месту пребывания';

  const headers = [
    'ФИО, республика, край, город, дата рождения',
    'Родственные отношения',
    'Паспорт, №, серия паспорта, кем выдан',
    'С какого времени прож. в Москве',
    'Дата регистрации и откуда прибыл',
    'Когда и куда выбыл',
  ];

  const rows = peopleByPreb.map((p, index) => [
    `${index + 1}.   ${mayBe(p.fio)} ${mayBe(p.birthLocation)} ${mayBe(p.birthDate, 'г.р.')}`,
    mayBe(p.relType),
    mayBe(p.passport),
    mayBe(p.arriveMoscow),
    p.regDate ? `${mayBe(p.regDate)} ${mayBe(p.regFrom)}` : 'без регистрации',
    mayBe([p.outWhere, p.outDate].join(' ')),
  ]);

  const empty = 'Не зарегистрированы';

  return { title, headers, rows, empty };
};

export const prepareRegPeopleTableData = (people: EGDPerson[], dopAttr: string) => {
  const peopleByReg = regPeoples(people);

  const title =
    dopAttr !== '8'
      ? 'На данной площади зарегистрированы по месту жительства'
      : 'Жилое помещение расположено в доме-новостройке и в нем никто не зарегистрирован';

  const headers = [
    'ФИО, республика, край, город, дата рождения',
    'Родственные отношения',
    'Паспорт, №, серия паспорта, кем выдан',
    'С какого времени прож. в Москве',
    'Дата регистрации и откуда прибыл',
    'Когда и куда выбыл',
  ];

  const rows = peopleByReg.map((p, index) => [
    `${index + 1}.   ${mayBe(p.fio)} ${mayBe(p.birthLocation)} ${mayBe(p.birthDate, 'г.р.')}`,
    mayBe(p.relType),
    mayBe(p.passport),
    mayBe(p.arriveMoscow),
    p.regDate ? `${mayBe(p.regDate)} ${mayBe(p.regFrom)}` : 'без регистрации',
    mayBe([p.outWhere, p.outDate].join(' ')),
  ]);

  const empty = 'Не зарегистрированы';

  return { title, headers, rows, empty };
};

export const prepareOwnersTableData = (owners: EGDOwner[]) => {
  const headers = ['ФИО владельца права собственности', 'Доля в праве собственности'];
  const title = 'Собственники';
  const rows = isArray(owners)
    ? owners.map((owner, index) => [
        `${index + 1}. ${mayBe(owner.fio)}`,
        owner.onePart === '1' ? 'без определения долей' : mayBe(owner.ownPerc, '%'),
      ])
    : [];

  const empty = 'Нет данных';

  return { title, headers, rows, empty };
};
